import {Grid} from '@mantine/core';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as Colors from 'ui-library/Colors';

import {GridSection as GridSectionType, NestedGrid, Tab} from './DataLayoutTypes';
import GridBlock, {gridBlockStyles} from './GridBlock';

interface GridSectionProps {
  gridSection: GridSectionType | NestedGrid | Tab;
  layoutPath: Array<string | number>;
  isInCombinedBlock?: boolean;
}

/** @package */
export default function GridSection({
  gridSection: {gridMode, rows},
  layoutPath,
  isInCombinedBlock = false,
}: GridSectionProps): JSX.Element {
  const isCurrentBlockCombined = gridMode === 'COMBINED' || isInCombinedBlock;
  return (
    <Grid
      className={css(
        gridMode === 'COMBINED' && styles.combinedBlock,
        gridMode === 'COMBINED' && !isInCombinedBlock && gridBlockStyles.blockBorder,
        isInCombinedBlock && gridMode === 'COMBINED' && styles.nestedCombinedBlock
      )}
    >
      {rows
        .map((row, rowIndex) =>
          row.map((block, columnIndex) => (
            <Grid.Col span={12 / row.length} key={`block-${rowIndex}-${columnIndex}`}>
              {block.type === 'NESTED_GRID' ? (
                <GridSection
                  gridSection={block}
                  layoutPath={[...layoutPath, 'rows', rowIndex, columnIndex]}
                  isInCombinedBlock={block.gridMode === 'COMBINED' || isCurrentBlockCombined}
                />
              ) : (
                <GridBlock
                  block={block}
                  key={`block-${rowIndex}-${columnIndex}`}
                  layoutPath={[...layoutPath, 'rows', rowIndex, columnIndex]}
                  hasBorder={!isCurrentBlockCombined}
                />
              )}
            </Grid.Col>
          ))
        )
        .flat()}
    </Grid>
  );
}

const styles = StyleSheet.create({
  combinedBlock: {
    backgroundColor: Colors.WHITE,
    // Needs extra margin to match the non-combined blocks
    margin: '2px 0',
  },
  nestedCombinedBlock: {
    backgroundColor: Colors.WHITE,
    border: 'none',
    margin: '0',
  },
});
